export const getters = {
  getValuesAddedToChartCheck: (state) => {
    return state.valuesAddedToChart;
  },

  getUpdatedChartValues: (state) => {
    return state.updatedChartValues;
  },

  getPeriodic: (state) => {
    return state.periodic;
  },

  getNames: (state) => {
    return state.names;
  },

  getRecords: (state) => {
    return state.records;
  },

  getChart: (state) => {
    return state.chartDataList;
  },

  // *************************************
  getTabContent: (state) => (tabIndex) => {
    //const encounter = state.encounters[tabIndex]
    //return encounter.content
    // return state.chartDataList;
    return state.selectedRecords[
      state.selectedRecords.indexOf(state.currentlySelectedRecord)
    ];
  },

  getCategoryData: (state) => {
    return state.categoryData;
  },

  getSelectedTemplates: (state) => {
    return state.selectedTemplates;
  },

  getSelectedCategories: (state) => {
    return state.selectedCategories;
  },

  getNewTemplate: (state) => {
    return state.newTemplate;
  },
  getEncounters: (state) => {
    return state.encounters;
  },
  getActiveRecord: (state) => {
    if (state.selectedRecords) {
      return state.selectedRecords[state.currentlySelectedRecordIndex];
    }
  },
  ///// record viewer ////
  getRecord: (state) => {
    for (let record of state.selectedRecords) {
      if (state.currentlySelectedTab.recordId == record._id) {
        return record;
      }
    }
  },
  getCurrentlySelectedRecordTab: (state) => {
    return state.currentlySelectedRecordTab;
  },

  getRecordItem: (state) => {
    let correctrecord;
    function findRecordItemById(RecordItemId, Record) {
      if (Record._id == RecordItemId) {
        correctrecord = Record;
      }

      for (let x = 0; x < Record.children.length; x++) {
        findRecordItemById(RecordItemId, Record.children[x]);
      }
    }
    // end of func declaration

    if (state.selectedRecords?.length) {
      for (let record of state.selectedRecords) {
        //cant find a way to get function to stop when record is found . for now log(n)

        if (state.currentlySelectedTab.recordId == record._id) {
          findRecordItemById(state.currentlySelectedTab.recordItemId, record);
        }
      }
    }

    return correctrecord;
  },

  ///////////////////////

  //// Groups ///
  getGroupByTab: (state) => {
    if (state.currentlySelectedTab) {
      return state.groups[state.currentlySelectedTab.recordId];
    } else {
      return {};
    }
  },
  getGroupByRecord: (state) => {
    if (
      state.currentlySelectedRecord &&
      state.groups[state.currentlySelectedRecord._id]
    ) {
      return state.groups[state.currentlySelectedRecord._id];
    } else {
      return {};
    }
  },

  //// Analysis ///
  getAnalysisGroupByTab: (state) => {
    if (state.currentlySelectedTab) {
      return state.analysis[state.currentlySelectedTab.recordId];
    } else {
      return {};
    }
  },
  getAnalysisGroupByRecord: (state) => {
    if (
      state.currentlySelectedRecord &&
      state.groups[state.currentlySelectedRecord._id]
    ) {
      return state.analysis[state.currentlySelectedRecord._id];
    } else {
      return {};
    }
  },

  //// Events ///
  getEventsGroupByTab: (state) => {
    if (state.currentlySelectedTab) {
      return state.eventz[state.currentlySelectedTab.recordId];
    } else {
      return {};
    }
  },
  getEventsGroupByRecord: (state) => {
    state.currentRecordDateTimeStamp;
    state.eventz[state.currentlySelectedRecord._id];
    if (
      state.eventz[state.currentlySelectedRecord._id] &&
      state.currentRecordDateTimeStamp
    ) {
      return state.eventz[state.currentlySelectedRecord._id];
    } else {
      return {};
    }
  },
  // Scores ///
  doesScoreExist: (state) => (node_id) => {
    // Stupid eslint rule!
    return Object.prototype.hasOwnProperty.call(state.scores, node_id);
  },
  getScoreByNodeID: (state) => (node_id) => {
    if (state.scores[node_id] !== undefined) {
      return state.scores[node_id];
    } else {
      return null;
    }
  },
  ////ACCOUNTS////
  getCurrentlySelectedAccount: (state) => {
    return state.currentlySelectedAccount;
  },
};
